const mainColors = {
  primary: '#008080',
  purple: '#8f61d2',
  brown: '#8d6e63',
  pink: '#d63c70',
  neutral: '#b5bcc7',
  success: '#63a45f',
  warning: '#d29a4d',
  danger: '#c96d68',
  info: '#629dc4',
};

const lightStatusColors = {
  success: '#63a45f',
  danger: '#c96d68',
  warning: '#d29a4d',
  brown: '#967a70',
};

const darkStatusColors = {
  success: '#4f8f4b',
  danger: '#b95d56',
  warning: '#bd8128',
  brown: '#7f665e',
};

export const colors = {
  light: {
    bg: '#f7f9fc',
    surface: '#ffffff',
    surfaceAlt: '#f1f3f6',
    text: 'rgba(0, 0, 0, 0.87)',
    textMuted: 'rgba(0, 0, 0, 0.6)',
    border: 'rgba(0, 0, 0, 0.14)',
    divider: 'rgba(0, 0, 0, 0.14)',
    ...mainColors,
    ...lightStatusColors,
  },
  dark: {
    bg: '#15161a',
    surface: '#202025',
    surfaceAlt: '#1c1c1f',
    text: '#e8eaef',
    textMuted: 'rgba(232, 234, 239, 0.66)',
    border: 'rgba(232, 234, 239, 0.085)',
    divider: 'rgba(232, 234, 239, 0.07)',
    ...mainColors,
    primary: '#007f7f',
    purple: '#7f5eb8',
    pink: '#b94468',
    neutral: '#a4abb6',
    info: '#4d86b2',
    ...darkStatusColors,
  },
} as const;

export type ColorMode = keyof typeof colors;
